<template>
  <div class="position-relative">
    <!-- NAVBAR MỚI -->
    <HeaderNavBar v-if="!isEmbed" />

    <!-- NAVBAR CŨ (Ẩn) -->
    <nav class="navbar fixed-top bg-menu" id="navbar" v-if="false">
      <div class="container-fluid px-3 px-lg-5">
        <!-- Logo / Title -->
        <a href="/" class="navbar-brand-wrapper">
          <!-- Logo / Title -->
          <img src="@/assets/images/logo-con.png" alt="Festival Logo" class="navbar-logo" />

          <span class="navbar-brand-text"> Lễ hội trái cây tỉnh Đồng Tháp </span>
        </a>
        <!-- Mobile menu button -->
        <!-- <button
          class="navbar-toggler border-0 p-2"
          type="button"
          @click="toggleMobileMenu"
          aria-label="Toggle navigation"
        >
          <i class="mdi mdi-menu text-white"></i>
        </button> -->

        <!-- <div class="collapse navbar-collapse" id="navbarNav">
          <ul class="navbar-nav mx-auto">
            <li
              v-for="(item, index) in treeView"
              :key="index"
              class="nav-item dropdown"
            >
              <a
                class="nav-link text-white text-uppercase fw-bold px-3"
                href="javascript:void(0)"
                @click="handleGetIdMenu(item)"
              >
                {{ item.label }}
              </a>
              <ul v-if="item.children" class="dropdown-menu shadow border-0">
                <li v-for="child in item.children" :key="child.id">
                  <a
                    class="dropdown-item text-uppercase fw-bold"
                    href="javascript:void(0)"
                    @click="handleGetIdMenu(child)"
                  >
                    {{ child.label }}
                  </a>
                </li>
              </ul>
            </li>
          </ul>

           <div class="d-none d-lg-flex align-items-center">
            <b-dropdown
                v-if="currentUserAuth"
                right
                variant="link"
                toggle-class="text-white p-0"
                no-caret
            >
              <template #button-content>
                <img
                    :src="currentUserAuth.avatar ? url + currentUserAuth.avatar : require('@/assets/images/logo-con.png')"
                    class="rounded-circle me-2"
                    width="36"
                    height="36"
                    alt="Avatar"
                />
                <span class="fw-bold">{{ currentUserAuth.fullName || currentUserAuth.userName }}</span>
              </template>
<b-dropdown-item @click="handlePush('/tai-khoan')" v-if="currentUserAuth.menu">
  <i class="bx bx-cog me-2"></i> Trang quản trị
</b-dropdown-item>
<b-dropdown-item @click="handlePush('/thong-tin-ca-nhan')">
  <i class="bx bx-user me-2"></i> Thông tin cá nhân
</b-dropdown-item>
<b-dropdown-divider></b-dropdown-divider>
<b-dropdown-item @click="logout" class="text-danger">
  <i class="bx bx-power-off me-2"></i> Đăng xuất
</b-dropdown-item>
</b-dropdown>

</div>
</div> -->
      </div>
    </nav>

    <!-- MOBILE MENU OVERLAY -->
    <!-- <div
      v-if="showMobileMenu"
      class="mobile-menu-overlay"
      @click="closeMobileMenu"
    ></div> -->
    <!-- <div
        :class="['mobile-menu', { 'open': showMobileMenu }]"
    >
      <div class="mobile-menu-header">
        <span class="fw-bold text-white">Menu</span>
        <button @click="closeMobileMenu" class="btn-close btn-close-white"></button>
      </div>
      <ul class="mobile-menu-list">
        <li v-for="(item, index) in treeView" :key="index">
          <a
              href="javascript:void(0)"
              @click="handleGetIdMenu(item)"
              class="mobile-menu-link text-uppercase fw-bold"
          >
            {{ item.label }}
          </a>
          <ul v-if="item.children" class="mobile-submenu">
            <li v-for="child in item.children" :key="child.id">
              <a
                  href="javascript:void(0)"
                  @click="handleGetIdMenu(child)"
                  class="mobile-submenu-link"
              >
                {{ child.label }}
              </a>
            </li>
          </ul>
        </li>

        <li class="mt-4 pt-3 border-top" v-if="currentUserAuth">
          <div class="d-flex align-items-center px-3 mb-3">
            <img
                :src="currentUserAuth.avatar ? url + currentUserAuth.avatar : require('@/assets/images/logo-con.png')"
                class="rounded-circle me-3"
                width="40"
                height="40"
                alt="Avatar"
            />
            <div>
              <div class="text-white fw-bold">{{ currentUserAuth.fullName }}</div>
              <div class="text-light small">@{{ currentUserAuth.userName }}</div>
            </div>
          </div>
          <div class="px-3">
            <button @click="handlePush('/tai-khoan')" class="btn btn-sm btn-light w-100 mb-2"
                    v-if="currentUserAuth.menu">
              <i class="bx bx-cog me-1"></i> Trang quản trị
            </button>
            <button @click="handlePush('/thong-tin-ca-nhan')" class="btn btn-sm btn-outline-light w-100 mb-2">
              <i class="bx bx-user me-1"></i> Thông tin cá nhân
            </button>
            <button @click="logout" class="btn btn-sm btn-danger w-100">
              <i class="bx bx-power-off me-1"></i> Đăng xuất
            </button>
          </div>
        </li>
        <li v-else class="mt-4 pt-3 border-top">
          <button @click="showModal = true; closeMobileMenu()" class="btn btn-warning w-100 text-danger fw-bold">
            ĐĂNG NHẬP
          </button>
        </li>
      </ul>
    </div> -->

    <!-- CONTENT -->
    <div v-scroll-spy>
      <slot></slot>
    </div>

    <!-- FOOTER -->
    <Footer v-if="!isEmbed" />

    <!-- <LoadingTET v-if="$store.state.app.isLoading" /> -->
    <!-- Chia đôi màn hình -->
    <transition name="split-exit">
      <LoadingTET v-if="$store.state.app.isLoading" />
    </transition>
    <!-- BACK TO TOP -->
    <button v-if="showButton && !isEmbed" @click="scrollToTop" class="btn-back-to-top" title="Lên đầu trang">
      <i class="mdi mdi-chevron-up" style="font-size: 24px"></i>
    </button>

    <!-- Tạo bài viết -->
    <!-- <div v-b-modal.create-news-modal class="floating-buttons">
      <button class="btn-floating-action shadow-lg" title="Thêm bài viết">
        <img :src="iconPostUrl" alt="Chia sẻ cảm" class="floating-icon-svg" />
      </button>
      <span class="floating-text">Chia sẻ cảm xúc</span>

    </div> -->

    <FormCreateFeed />
    <!-- LOGIN MODAL -->
    <b-modal v-model="showModal" centered hide-header hide-footer no-close-on-backdrop size="sm">
      <div class="p-4">
        <div class="text-center mb-4">
          <img src="@/assets/images/4.png" height="80" alt="Logo" />
        </div>
        <h5 class="text-main mb-2 text-center">Đăng nhập</h5>
        <b-form @submit.prevent="Login" ref="formContainer">
          <b-form-group label="Tài khoản" class="mb-3">
            <b-form-input v-model="model.userName" :class="{ 'is-invalid': submitted && $v.model.userName.$error }"
              placeholder="Nhập tên đăng nhập"></b-form-input>
            <div v-if="submitted && !$v.model.userName.required" class="invalid-feedback">
              Vui lòng nhập tài khoản
            </div>
          </b-form-group>
          <b-form-group label="Mật khẩu" class="mb-3">
            <b-form-input v-model="model.password" type="password"
              :class="{ 'is-invalid': submitted && $v.model.password.$error }"
              placeholder="Nhập mật khẩu"></b-form-input>
            <div v-if="submitted && !$v.model.password.required" class="invalid-feedback">
              Vui lòng nhập mật khẩu
            </div>
          </b-form-group>
          <div class="d-grid gap-2">
            <b-button type="submit" variant="success">Đăng nhập</b-button>
            <b-button variant="secondary" @click="showModal = false">Đóng</b-button>
          </div>
        </b-form>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { required } from "vuelidate/lib/validators";

import axios from "axios";
import moment from "moment";
import { FormCreateFeed } from "@/components/widgets";

import LoadingTET from "@/components/widgets/loadingRouting";
import HeaderNavBar from "@/pages/public/home/components/HeaderNavBar.vue";
import Footer from "@/layouts/footer.vue";

export default {
  components: {
    FormCreateFeed,
    LoadingTET,
    HeaderNavBar,
    Footer
  },
  data() {
    return {
      appVersion: process.env.VUE_APP_VERSION,
      showButton: false,
      showMobileMenu: false, // Trạng thái menu mobile
      treeView: [],
      currentUserAuth: null,
      model: { userName: "", password: "" },
      submitted: false,
      showModal: false,
      url: `${process.env.VUE_APP_API_URL}filesminio/view/`,
      idMenu: "",
    };
  },
  validations: {
    model: {
      userName: { required },
      password: { required },
    },
  },
  watch: {
    "$route.query.lang": {
      immediate: true,
      handler(newLang) {
        if (newLang) {
          const queryLang = newLang.toLowerCase();
          if (["vi", "en"].includes(queryLang) && this.$i18n) {
            this.$i18n.locale = queryLang;
            localStorage.setItem("user-locale", queryLang);
          }
        }
      },
    },
  },
  created() {
    const authUser = localStorage.getItem("auth-user");
    if (authUser) {
      this.currentUserAuth = JSON.parse(authUser);
    }
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    // this.GetTreeList();
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  computed: {
    ...mapState("snackBarStore", ["notify", "registerModal"]),
    iconPostUrl() {
      return require("@/assets/images/postIcon.png");
    },
    isEmbed() {
      return this.$route.query.embed === 'true' || this.$route.query.iframe === 'true';
    }
  },
  methods: {
    handleScroll() {
      this.showButton = window.scrollY > 500;
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    toggleMobileMenu() {
      this.showMobileMenu = !this.showMobileMenu;
    },
    closeMobileMenu() {
      this.showMobileMenu = false;
    },
    async GetTreeList() {
      await this.$store.dispatch("menuCongDanStore/getTreeList").then((res) => {
        this.treeView = res.data || [];
      });
    },
    handleGetIdMenu(item) {
      if (item.id === this.idMenu) return;

      let path = item.link;
      if (path.includes("/{id}")) {
        path = path.replace("{id}", item.id);
      } else if (item.level !== 0) {
        path = `${path}/${item.id}`;
      }
      this.idMenu = item.id;
      this.$router.push(path).catch(() => { });
      this.closeMobileMenu(); // Đóng menu sau khi chọn
    },
    async Login(e) {
      e.preventDefault();
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) return;

      const loader = this.$loading.show({
        container: this.$refs.formContainer,
      });
      try {
        const res = await this.$store.dispatch("authStore/login", this.model);
        if (res.code === 0) {
          localStorage.setItem("auth-user", JSON.stringify(res.data));
          localStorage.setItem(
            "user-token",
            JSON.stringify(res.data.accessToken)
          );
          this.currentUserAuth = res.data;
          this.showModal = false;
          this.$notify({
            group: "foo",
            title: "Thành công",
            type: "success",
            text: res.message,
          });
          if (res.data.menu) this.$router.push("/tai-khoan");
        } else {
          this.$notify({
            group: "foo",
            title: "Lỗi",
            type: "warn",
            text: res.message,
          });
        }
      } catch (err) {
        this.$notify({
          group: "foo",
          title: "Lỗi",
          type: "error",
          text: "Đăng nhập thất bại",
        });
      } finally {
        loader.hide();
        this.submitted = false;
      }
    },
    logout() {
      localStorage.removeItem("user-token");
      localStorage.removeItem("auth-user");
      this.currentUserAuth = null;
      this.$store.dispatch("authStore/setCurrentUser", null);
      this.$router.push("/").catch(() => { });
    },
    handlePush(path) {
      if (this.$route.path !== path) this.$router.push(path);
      this.closeMobileMenu();
    },
  },
};
</script>
<style scoped>
/* Navbar */

.split-exit-enter {
  transform: translateY(-100%) !important;
  /* Bắt đầu ở trên cùng */
  opacity: 0.5;
}

.split-exit-enter-active {
  transition: transform 0.8s ease-out, opacity 0.8s ease-out !important;
}

.split-exit-enter-to {
  transform: translateY(0) !important;
  /* Vào vị trí chuẩn */
  opacity: 1;
}

/* 2. KHI BIẾN MẤT (LEAVE): Tiếp tục trượt xuống dưới */
.split-exit-leave {
  transform: translateY(0) !important;
  opacity: 1;
}

.split-exit-leave-active {
  transition: transform 0.8s ease-in, opacity 0.8s ease-in !important;
}

.split-exit-leave-to {
  transform: translateY(100%) !important;
  /* Trượt xuống đáy */
  opacity: 0;
}

.navbar {
  padding: 0.65rem 0;
  transition: all 0.3s ease;
  z-index: 1030;
  width: 100%;
}

/* Wrapper cho Logo và Title */
.navbar-brand-wrapper {
  display: flex;
  align-items: center;
  /* Căn giữa dọc giữa logo và text */
  text-decoration: none;
}

/* Style cho Logo */
.navbar-logo {
  /* Đảm bảo logo có chiều cao cố định và tự động điều chỉnh chiều rộng */
  height: 40px;
  /* Chiều cao tối ưu cho Navbar */
  width: auto;
  object-fit: contain;
  /* QUAN TRỌNG: Giữ nguyên tỷ lệ và không bị méo */
  margin-right: 10px;
  transition: height 0.3s ease;
}

/* Style cho Text Title */
.navbar-brand-text {
  color: var(--color-white, #ffffff);
  font-weight: 700;
  font-size: 1.25rem;
}

.navbar-brand {
  font-size: 1.2rem;
  color: #fff;
}

/* Mobile Menu */
.mobile-menu-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 1040;
  backdrop-filter: blur(5px);
}

.mobile-menu {
  position: fixed;
  top: 0;
  right: -100%;
  /* Ẩn bên phải */
  width: 280px;
  height: 100vh;
  background: var(--color-primary, #2b569a);
  z-index: 1050;
  transition: right 0.3s ease;
  overflow-y: auto;
  box-shadow: -5px 0 15px rgba(0, 0, 0, 0.3);
}

.mobile-menu.open {
  right: 0;
}

.mobile-menu-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  background: rgba(0, 0, 0, 0.2);
}

.mobile-menu-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.mobile-menu-link,
.mobile-submenu-link {
  display: block;
  padding: 0.75rem 1.5rem;
  color: white;
  text-decoration: none;
  transition: 0.2s;
}

.mobile-menu-link:hover,
.mobile-submenu-link:hover {
  background: rgba(255, 255, 255, 0.1);
  padding-left: 2rem;
}

.mobile-submenu {
  background: rgba(0, 0, 0, 0.2);
  padding-left: 1rem;
  list-style: none;
}

/* Dropdown Desktop */
.dropdown-menu {
  min-width: 200px;
  border-radius: 8px;
  margin-top: 8px;
}

/* Back to top */
.btn-back-to-top {
  position: fixed;
  bottom: 30px;
  right: 20px;
  background: var(--primary);
  color: white;
  width: 55px;
  height: 55px;
  border-radius: 50%;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  z-index: 1000;
  opacity: 0.9;
  transition: 0.3s;
}

.btn-back-to-top:hover {
  opacity: 1;
  transform: translateY(-3px);
}

.floating-buttons {
  position: fixed;
  bottom: 15px;
  left: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* canh giữa 2 nút theo trục ngang */
  gap: 5px;
  /* khoảng cách giữa 2 nút */
  z-index: 1000;

  transition: all 0.3s ease;
}

/* Nút tròn vàng */
.btn-floating-action {
  width: 55px;
  height: 55px;
  border-radius: 50%;
  border: none;
  background-color: rgba(255, 255, 255, 0.75);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;

  box-shadow: 0 0 10px var(--color-primary);
}

/* .btn-floating-action:hover {
  transform: scale(1.1);
  box-shadow: 0 10px 15px rgba(250, 61, 61, 0.8);
} */

.floating-buttons:hover {
  transform: scale(1.05);
}

/* NEW: Style cho SVG Icon */
.floating-icon-svg {
  width: 45px;
  /* Kích thước icon SVG */
  height: 45px;
  object-fit: contain;
}

.floating-text {
  font-size: 0.75rem;
  font-weight: 700;
  color: var(--color-primary);
  /* Sử dụng màu chính để nổi bật */
  background-color: rgba(255, 255, 255, 0.75);
  padding: 4px 8px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  white-space: nowrap;
  /* Không xuống dòng */
  cursor: pointer;
  /* Cho phép click */
  border: 1px solid rgba(0, 0, 0, 0.05);
  transition: transform 0.2s ease;
}

/* Nút book */
.btn-floating-book {
  background: white;
  padding: 10px;
  border-radius: 45%;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  transition: 0.3s;
}

.btn-floating-book:hover {
  transform: scale(1.1);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
}

/* Đảm bảo hình nền footer full width */
footer.landing-footer img {
  display: block;
  width: 100%;
  height: auto;
}

/* Background cho modal login */
.bg-login {
  background-size: cover;
  background-position: center;
  min-height: 180px;
  border-radius: 8px 8px 0 0;
  margin: -1.5rem -1.5rem 1rem -1.5rem;
}




.bg-footer {
  height: 30px;
  background-color: var(--color-primary);
  color: var(--color-white);
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Nút đăng nhập */
.btn-login {
  right: 10px;
  padding: 7px 2px;
  margin-right: 10px;
  position: absolute;
  background: var(--color-accent-yellow);
  color: white;
  border-radius: 12px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 1px 1px 12px rgba(244, 113, 118, 0.5);
  transition: 0.3s;
}

.btn-lk {
  position: fixed;
  bottom: 30px;
  left: 30px;
  z-index: 999;
  background: white;
  padding: 12px;
  border-radius: 50%;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

/* ========================================
   RESPONSIVE DESIGN - TẤT CẢ MÀN HÌNH
   ======================================== */

/* Extra small devices (phones, < 576px) */
@media (max-width: 576px) {
  .navbar {
    padding: 0.15rem 0 !important;
    transition: all 0.3s ease;
    z-index: 1030;
  }

  .navbar-brand {
    font-size: 0.75rem;
    font-weight: bold;
    justify-content: center;
  }

  .btn-lk,
  .btn-back-to-top {
    width: 45px;
    height: 45px;
    padding: 8px;
    font-size: 20px;
  }

  .btn-lk {
    bottom: 20px;
    left: 15px;
  }

  .btn-back-to-top {
    bottom: 20px;
    right: 15px;
  }

  .mobile-menu {
    width: 260px;
  }

  .mobile-menu-link,
  .mobile-submenu-link {
    padding: 0.6rem 1.2rem;
    font-size: 0.9rem;
  }

  .mobile-menu-header {
    padding: 0.8rem;
  }

  .bg-login {
    min-height: 140px;
  }

  .card-body {
    padding: 8px 4px !important;
  }

  .avatar-md img {
    height: 60px !important;
  }

  .floating-buttons {}

  .floating-icon-svg {
    width: 40px;
    /* Kích thước icon SVG */
    height: 40px;
    /* padding: ; */
  }

  .floating-text {
    font-size: 0.65rem;
    font-weight: 600;
    padding: 4px 6px;
  }

  footer .container {
    padding: 15px;
  }

  .bg-footer {
    font-size: 0.7rem !important;
  }
}

/* Small devices (landscape phones, 576px - 767px) */
@media (min-width: 576px) and (max-width: 768px) {
  .navbar-brand {
    font-size: 0.9rem;
  }

  .btn-lk,
  .btn-back-to-top {
    width: 48px;
    height: 48px;
  }

  .mobile-menu {
    width: 280px;
  }

  .bg-login {
    min-height: 160px;
  }

  .avatar-md img {
    height: 70px !important;
  }

  .bg-footer {
    font-size: 0.8rem !important;
  }
}

/* Medium devices (tablets, 768px - 991px) */
@media (min-width: 768px) and (max-width: 992px) {
  .navbar {
    padding: 0.5rem 0;
  }

  .navbar-brand {
    font-size: 1rem;
  }

  .navbar-nav .nav-link {
    font-size: 0.9rem;
    padding: 0.5rem 0.8rem !important;
  }

  .dropdown-menu {
    min-width: 180px;
    font-size: 0.9rem;
  }

  .mobile-menu {
    width: 300px;
  }

  .btn-lk,
  .btn-back-to-top {
    width: 50px;
    height: 50px;
  }

  .bg-login {
    min-height: 180px;
  }

  .bg-footer {
    font-size: 0.9rem !important;
  }
}

/* Large devices (laptops, 992px - 1199px) */
@media (min-width: 992px) and (max-width: 1200px) {
  .navbar {
    padding: 0.65rem 0;
  }

  .navbar-brand {
    font-size: 1.1rem;
  }

  .navbar-nav .nav-link {
    font-size: 0.95rem;
    padding: 0.5rem 1rem !important;
  }

  .dropdown-menu {
    min-width: 200px;
  }

  .mobile-menu {
    width: 320px;
  }

  .btn-lk,
  .btn-back-to-top {
    width: 52px;
    height: 52px;
  }
}

/* Extra large devices (desktops, ≥ 1200px) */
@media (min-width: 1200px) {
  .navbar {
    padding: 0.75rem 0;
  }

  .navbar-brand {
    font-size: 1.2rem;
  }

  .navbar-nav .nav-link {
    font-size: 1rem;
    padding: 0.5rem 1.2rem !important;
  }

  .dropdown-menu {
    min-width: 220px;
  }

  .mobile-menu {
    width: 340px;
  }

  .btn-lk,
  .btn-back-to-top {
    width: 55px;
    height: 55px;
  }
}

/* Ẩn collapse navbar trên mobile */
@media (max-width: 992px) {
  .navbar-collapse {
    display: none !important;
  }

  .navbar.scrolled {
    background-color: rgba(43, 86, 154, 0.98) !important;
    backdrop-filter: blur(10px);
  }
}

@media (min-width: 1512px) and (min-height: 982px) {
  .navbar {
    padding: 0.75rem 0;
  }

  .navbar-brand {
    font-size: 1.6rem;
  }

  .btn-login {
    padding: 0.75rem;
    font-size: 0.85rem;
  }

  .navbar-nav .nav-link {
    font-size: 1.1rem;
    padding: 0.5rem 1.1rem !important;
  }

  .dropdown-menu {
    min-width: 220px;
  }

  .mobile-menu {
    width: 340px;
  }

  .btn-lk,
  .btn-back-to-top {
    width: 55px;
    height: 55px;
  }
}

/* Đảm bảo mobile menu không bị cắt */
.mobile-menu {
  -webkit-overflow-scrolling: touch;
}

/* Footer hình nền không bị méo */
footer.landing-footer img {
  object-fit: cover;
  width: 100%;
  height: auto;
  display: block;
}

/* Tối ưu modal trên mobile */
@media (max-width: 576px) {
  .modal-dialog {
    margin: 10px;
  }

  .modal-content {
    border-radius: 12px;
  }

  .btn-block {
    font-size: 0.9rem;
    padding: 8px;
  }
}

/* Responsive Fixes */
@media (max-width: 767.98px) {
  .navbar {
    height: 55px;
  }

  .navbar-logo {
    height: 35px;
    /* Giảm nhẹ chiều cao logo trên mobile */
  }

  .navbar-brand-text {
    font-size: 1.1rem;
    /* Giảm size chữ trên mobile */
  }
}
</style>
